<template>
  <div id="visit">
    <header-top showBack :routerInfo="'/reservation/index'"></header-top>
    <div class="header-title show-back">添加带看</div>
    <el-form
      :model="visitInfo"
      :rules="visitRules"
      ref="visitInfo"
      label-width="6rem"
      label-position="left"
    >
      <div class="visit-detail">
        <div class="detail-tit">带看信息</div>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="visitTime" label="带看日期">
              <el-date-picker
                v-model="visitInfo.visitTime"
                type="datetime"
                placeholder="选择日期时间"
                value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="brokerInfo" label="陪看人">
              <el-select
                v-model="visitInfo.brokerId"
                clearable
                filterable
                remote
                reserve-keyword
                :remote-method="getUsers"
                :loading="selectLoading"
                placeholder="请选择陪看人"
              >
                <el-option
                  v-for="(item, index) in users"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                  @click.native="getCustomerInfo(index)"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="带看确认单" class="auto-height">
              <div class="visit-img">
                <div
                  class="photo-item"
                  v-for="(item, index) in uploadPhotoList"
                  :key="index"
                >
                  <div class="img-box">
                    <img :src="item.url" class="photo-img" />
                    <div class="del-btn">
                      <span @click="delPhotoItme(index)">删除</span>
                    </div>
                  </div>
                </div>
                <el-upload
                  ref="upload"
                  action="https://jsonplaceholder.typicode.com/posts/"
                  :on-change="handlePictureCardPreview"
                  :file-list="uploadPhotoList"
                  :show-file-list="false"
                  :auto-upload="false"
                  multiple
                  accept=".jpg, .png, .jpeg"
                >
                  <div class="upload-btn">
                    <i slot="default" class="el-icon-plus"></i>
                    <span>最多上传5张图片</span>
                  </div>
                </el-upload>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="12">
            <el-form-item label="其他附件" class="auto-height">
              <div class="visit-img">
                <div
                  class="photo-item"
                  v-for="(item, index) in uploadOtherPhotoList"
                  :key="index"
                >
                  <div class="img-box">
                    <img :src="item.url" class="photo-img" />
                    <div class="del-btn">
                      <span @click="delOtherPhotoItme(index)">删除</span>
                    </div>
                  </div>
                </div>
                <el-upload
                  ref="upload"
                  action="https://jsonplaceholder.typicode.com/posts/"
                  :on-change="handleotherImgPreview"
                  :file-list="uploadOtherPhotoList"
                  :show-file-list="false"
                  :auto-upload="false"
                  multiple
                  accept=".jpg, .png, .jpeg"
                >
                  <div class="upload-btn">
                    <i slot="default" class="el-icon-plus"></i>
                    <span>最多上传5张图片</span>
                  </div>
                </el-upload>
              </div>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row>
          <el-col :span="12">
            <el-form-item prop="business" label="带看情况" class="auto-height">
              <el-input
                v-model="visitInfo.more"
                placeholder="请输入带看情况"
                type="textarea"
                maxlength="500"
                show-word-limit
                resize="none"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="basics-deail">
        <div class="detail-tit">基础信息</div>
        <el-row>
          <el-col :span="24">
            <el-form-item
              prop="estateInfo"
              label="报备楼盘"
              class="auto-height"
              v-if="reservationInfo.estateInfo"
            >
              <div class="estate-info">
                <div class="estate-main">
                  <img
                    class="estate-cover"
                    v-if="!reservationInfo.estateInfo.hasCover"
                    src="@/assets/image/estate-cover.jpg"
                    alt=""
                  />
                  <img
                    class="estate-cover"
                    v-if="reservationInfo.estateInfo.hasCover"
                    :src="reservationInfo.estateInfo.photoCoverUrl"
                    alt=""
                  />
                  <div class="edtate-detail">
                    <div class="name">
                      {{ reservationInfo.estateInfo.estateName
                      }}<span class="status">{{
                        reservationInfo.estateInfo.saleStatus
                      }}</span>
                    </div>
                    <div class="address">
                      {{ reservationInfo.estateInfo.city }}-{{
                        reservationInfo.estateInfo.street
                      }}-{{ reservationInfo.estateInfo.business }}
                    </div>
                    <div class="info">
                      报备号码: {{ reservationRule.numberType | nullValue }} |
                      报备有效时长 ：{{
                        reservationRule.protectedNumber | nullValue
                      }}{{ reservationRule.protectedUnit | nullValue }}
                    </div>
                  </div>
                </div>
                <div class="estate-price">
                  {{ reservationInfo.estateInfo.minPrice }}元/㎡
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="customerName" label="客户姓名">
              <span>{{ reservationInfo.customerName | nullValue }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="customerPhoneNumber" label="客户号码">
              <span>{{ reservationInfo.customerPhoneNumber | nullValue }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="creatorName" label="经纪人姓名">
              <span>{{ reservationInfo.creatorName | nullValue }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="creatorPhoneNumber" label="经纪人号码">
              <span>{{ reservationInfo.creatorPhoneNumber | nullValue }}</span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="channelName" label="分销商姓名">
              <span>{{ reservationInfo.channelName | nullValue }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="channelOrganizationUnit" label="分销商所属机构">
              <span>{{
                reservationInfo.channelOrganizationUnit | nullValue
              }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="reservation-detail">
        <div class="detail-tit">
          客户联系人<span
            v-if="permissions['Customer.LookPhoneNumber']"
            class="show-contracts"
            @click="showContracts"
            >查看联系方式</span
          >
        </div>
        <div class="flex reservation-items">
          <el-table :data="reservationInfo.contracts" border>
            <el-table-column prop="name" label="姓名"> </el-table-column>
            <el-table-column prop="gender" label="性别"> </el-table-column>
            <el-table-column prop="phoneNumber" label="电话"> </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="reservation-detail">
        <div class="detail-tit">报备信息</div>
        <div class="flex reservation-items">
          <div class="reservation-item">
            <el-form-item label="到访日期">
              <span>{{ reservationInfo.visitTime | nullValue }}</span>
            </el-form-item>
          </div>
          <div class="reservation-item">
            <el-form-item prop="visitPersonNumber" label="到访人数">
              <span>{{ reservationInfo.visitPersonNumber | nullValue }}</span>
            </el-form-item>
          </div>
        </div>
        <div class="flex reservation-items">
          <div
            class="reservation-item"
            v-for="(item, index) in reservationInfo.fields"
            :key="index"
          >
            <el-form-item :label="item.name">
              <div v-if="item.fieldType == '上传附件'">
                <div v-if="item.savedContent.length">
                  <div v-if="item.savedContent.length == 1">
                    <div
                      v-for="(item, index) in item.savedContent"
                      :key="index"
                      class="flex"
                    >
                      <div class="file-item flex">
                        <el-image
                          :ref="item.fileId"
                          :src="item.url"
                          :preview-src-list="[item.url]"
                        >
                        </el-image>
                        <span>{{ item.name }}</span>
                        <span
                          class="theme-color down-btn"
                          @click="downFile(item.fileId, item.name)"
                          >下载</span
                        >
                      </div>
                    </div>
                  </div>
                  <el-popover placement="top-start" trigger="hover">
                    <div>
                      <div
                        v-for="(el, i) in item.savedContent"
                        :key="i"
                        class="flex-between file-item pop-file"
                      >
                        <div class="flex">
                          <el-image
                            :ref="el.id"
                            v-if="el.fileType == 'image'"
                            :src="el.url"
                            :preview-src-list="[el.url]"
                          >
                          </el-image>
                          <img
                            src="@/assets/image/file-cover.png"
                            v-else
                            class="file-doc file-photo"
                          />
                          <span>{{ el.name }}</span>
                        </div>
                        <span
                          class="theme-color down-btn"
                          @click="downFile(el.fileId, el.name)"
                          >下载</span
                        >
                      </div>
                    </div>
                    <span
                      v-show="item.savedContent.length > 1"
                      class="file-itmes theme-color"
                      slot="reference"
                    >
                      <i class="el-icon-paperclip"></i>
                      <span>{{ item.savedContent.length }}</span
                      >个附件
                    </span>
                  </el-popover>
                </div>
                <div v-else>—</div>
              </div>
              <span v-else-if="item.fieldType == '日期选择'">{{
                item.savedContent | dayFormat
              }}</span>
              <span v-else-if="item.fieldType == '数字输入'">{{
                item.savedContent ? item.savedContent + item.content : "—"
              }}</span>
              <span v-else>{{ item.savedContent | nullValue }}</span>
            </el-form-item>
          </div>
        </div>
        <div class="flex reservation-items">
          <el-form-item prop="more" label="备注说明">
            <span>{{ reservationInfo.more | nullValue }}</span>
          </el-form-item>
        </div>
        <!-- <el-row>
          <el-col :span="12">
            <el-form-item label="到访日期">
              <span>{{ reservationInfo.visitTime | nullValue }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="visitPersonNumber" label="到访人数">
              <span>{{ reservationInfo.visitPersonNumber | nullValue }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="more" label="备注说明">
              <span>{{ reservationInfo.more | nullValue }}</span>
            </el-form-item>
          </el-col>
        </el-row> -->
      </div>
      <div class="btn-box">
        <el-button
          type="primary"
          @click="submit('visitInfo')"
          :loading="submitLoading"
          >提交</el-button
        >
        <el-button @click="toReservation">取消</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import headerTop from "@/components/HeaderTop";
import {
  getReservationInfo,
  createVisit,
  uploadVisit,
  uploadVisitMaterials,
  getCustomerPhone,
} from "@/http/api/reservations";
import { getReservationRule } from "@/http/api/marketing";
import { getUsers } from "@/http/api/employe";
import { get } from "js-cookie";
export default {
  components: {
    headerTop,
  },
  data() {
    return {
      id: this.$route.params.id,
      reservationInfo: {},
      reservationRule: {},
      selectLoading: false,
      submitLoading: false,
      users: [],
      visitInfo: {
        brokerId: "",
        organizationUnit: "",
        brokerName: "",
        visitTime: null,
        more: "",
      },
      visitImg: [],
      uploadPhotoList: [],
      uploadOtherPhotoList: [],
      brokerInfo: "",
      contracts: [],
      permissions: {},
      visitRules: {
        estateName: [
          {
            required: true,
            trigger: "change",
            message: "请选择楼盘",
          },
        ],
        visitImg: [
          {
            required: true,
            trigger: "change",
            message: "请上传带看单",
          },
        ],
        visitTime: [
          {
            required: true,
            trigger: "change",
            message: "请选择到访时间",
          },
        ],
      },
    };
  },
  mounted() {
    this.getReservationInfo();
    this.getUsers();
    this.permissions = this.$store.getters.permissions;
  },
  methods: {
    showContracts() {
      if (this.permissions["Customer.LookPhoneNumber"]) {
        getCustomerPhone(this.id).then((res) => {
          //console.log(res, "联系人");
          this.contracts = res.result.contracts;
        });
      }
    },
    toReservation() {
      this.$router.push({ path: "/reservation/index" });
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          //console.log(this.visitInfo,'获取的带看');
          createVisit(this.id, this.visitInfo)
            .then((res) => {
              let formData = new FormData();
              formData.append("SourceType", "Accessory");
              this.submitLoading = false;
              this.uploadPhotoList.map((el, i) => {
                //console.log(el, 987);
                formData.append(`materials[${i}].File`, el.file);
                formData.append(`materials[${i}].Type`, el.file.type);
              });
              if (res) {
                this.$message.success({
                  message: res.message,
                  showClose: true,
                });
              }

              uploadVisitMaterials(this.id, res.result, formData).then(
                (res) => {
                  this.toReservation();
                }
              );
              // let formOtherData = new FormData();
              // formOtherData.append("SourceType", "Accessory");
              // this.uploadOtherPhotoList.map((el, i) => {
              //   formOtherData.append(`materials[${i}].File`, el.file);
              //   formOtherData.append(`materials[${i}].Type`, el.type);
              // });
              // uploadVisitMaterials(this.id, res.result,formOtherData).then(res=>{

              // });
            })
            .catch((err) => {
              this.submitLoading = false;
            });
        } else {
          //console.log("error submit!!");
          return false;
        }
      });
    },
    // 删除相册
    delPhotoItme(index) {
      this.uploadPhotoList.splice(index, 1);
    },
    handlePictureCardPreview(file) {
      if (this.uploadPhotoList.length < 5) {
        this.uploadPhotoList.push({
          file: file.raw,
          url: URL.createObjectURL(file.raw),
          checked: false,
          type: "",
          error: false,
        });
      } else {
        this.$message({
          message: "最多只允许上传5张图片",
          showClose: true,
        });
      }
    },
    // //其它相册
    // delOtherPhotoItme(index) {
    //   this.uploadOtherPhotoList.splice(index, 1);
    // },
    // handleotherImgPreview(file) {
    //   this.uploadOtherPhotoList.push({
    //     file: file.raw,
    //     url: URL.createObjectURL(file.raw),
    //     checked: false,
    //     type: "",
    //     error: false,
    //   });
    // },
    getCustomerInfo(val) {
      this.visitInfo.brokerId = this.users[val].id;
      this.visitInfo.brokerName = this.users[val].name;
      this.visitInfo.organizationUnit = this.users[val].organizationUnit;
    },
    //获取客源
    getUsers(val) {
      let query = "";
      if (val) {
        query = `Filter = ${val}&maxResultCount= 30`;
      } else {
        query = `maxResultCount= 30`;
      }

      getUsers(query).then((res) => {
        this.users = res.result.items;
        //console.log(res, "estates", this.users);
      });
    },
    getReservationInfo() {
      getReservationInfo(this.id).then((res) => {
        if (res.code == 10200) {
          this.reservationInfo = res.result;
          let estateId = res.result.estateInfo.estateId;
          this.getReservationRule(estateId);
          this.contracts = res.result.contracts;
          this.reservationInfo.fields.map((el) => {
            if (el.fieldType == "上传附件" && el.savedContent) {
              el.savedContent = JSON.parse(el.savedContent);
            }
          });
        }
      });
    },
    // 获取报备规则
    getReservationRule(estateId) {
      getReservationRule(estateId).then((res) => {
        if (res.result.protectedUnit) {
          this.reservationRule = res.result;
        }
      });
    },
  },
};
</script>
<style scoped lang='scss'>
@import "@/styles/mixin.scss";
@mixin tit {
  margin-bottom: 20px;
  padding: 20px;
  border-bottom: 1px solid #e0e0e0;
  color: #666666;
  font-size: 16px;
}
#visit {
  .el-form {
    padding: 20px;
    .visit-detail,
    .reservation-detail,
    .basics-deail {
      margin-bottom: 20px;
      border-radius: $--border-radius-base;
      background: #fff;
      .detail-tit {
        @include tit;
        .show-contracts {
          margin-right: 20px;
        }
      }
      .el-col {
        padding: 0 20px;
        ::v-deep .el-date-editor {
          .el-input__inner {
            padding-left: 30px;
          }
          .el-icon-circle-close {
            right: 0;
          }
        }
      }
      .estate-info {
        @include flex(row, center);
        justify-content: space-between;
        padding: 20px;
        background: #f7f7f7;
        .estate-main {
          @include flex(row, center);
          .estate-cover {
            margin-right: 30px;
            width: 160px;
            height: 116px;
          }
          .edtate-detail {
            @include flex(column, flex-start);
            justify-content: space-between;
            height: 116px;
            .name,
            .address {
              color: #444;
              .status {
                margin-left: 30px;
                // display: inline-block;
                padding: 2px 5px;
                border-radius: $--border-radius-base;
                font-size: 12px;
                color: #fff;
                background: $--color-primary;
              }
            }
            .info {
              color: #888;
            }
          }
        }
        .estate-price {
          font-size: 26px;
          color: $--color-primary;
        }
      }
    }

    .reservation-items {
      align-items: flex-start;
      flex-wrap: wrap;
      padding: 0 40px;
      .el-table {
        margin-bottom: 20px;
      }
      .reservation-item {
        width: 50%;

        .margin-bottom {
          margin-bottom: 0;
        }
      }
    }

    ::v-deep .visit-img {
      @include flex(row, center);
      .el-upload {
        border: 1px dashed #e0e0e0;
        border-radius: $--border-radius-base;
        width: 124px;
        height: 84px;
        line-height: 84px;
        .upload-btn {
          @include flex(column, center);
          justify-content: center;
          height: 84px;
          line-height: 84px;
          color: #858585;
          .el-icon-plus {
            font-size: 20px;
          }
          span {
            height: 30px;
            line-height: 30px;
            font-size: 12px;
          }
        }
      }
      .photo-item {
        position: relative;
        margin-right: 20px;
        width: 124px;
        height: 84px;
        line-height: 84px;
        transition: all 0.4s;
        .del-btn {
          position: absolute;
          top: 0;
          left: 0;
          width: 124px;
          height: 84px;

          background-color: transparent;
          transition: all 0.4s;
          span {
            position: absolute;
            right: 5px;
            bottom: 5px;
            height: 14px;
            line-height: 14px;
            cursor: pointer;
            color: transparent;
          }
        }

        &:hover {
          .del-btn {
            background-color: rgba(0, 0, 0, 0.5);
            span {
              color: #fff;
            }
          }
        }

        img {
          width: 124px;
          height: 84px;
        }
      }
    }
    .btn-box {
      padding: 20px;
      text-align: center;
      background: #fff;
    }
  }
}
.file-item {
  margin-right: 10px;
  margin-bottom: 10px;
  font-size: 14px;
  color: #000;

  &:last-child {
    margin-bottom: 0;
  }

  .el-image,
  img {
    margin-right: 10px;
    width: 30px;
    height: 30px;
  }

  span {
    display: inline-block;
    max-width: 260px;
    white-space: nowrap; /*内容超宽后禁止换行显示*/
    overflow: hidden; /*超出部分隐藏*/
    text-overflow: ellipsis; /*文字超出部分以省略号显示*/
  }

  i {
    margin-left: 5px;
    cursor: pointer;
  }

  &.pop-file {
    width: 340px;
  }

  .down-btn {
    display: inline-block;
    margin-left: 10px;
  }
}
</style>
